import React, { useState } from 'react';
import { updateBet } from '../api/mongoServices';

const EditBetModal = ({ bet, onClose }) => {
  const [amount, setAmount] = useState(bet.amount);
  const [luckyNumber, setLuckyNumber] = useState(bet.lucky_number);

  const handleSave = async () => {
    await updateBet(bet.bet_id, { amount, lucky_number: luckyNumber });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-[400px]">
        <h3 className="text-xl font-bold mb-4">Edit Lucky Pick</h3>

        <div className="mb-3">
          <label className="block mb-1 text-sm font-semibold">Amount</label>
          <input
            className="w-full border px-2 py-1"
            value={amount}
            onChange={e => setAmount(e.target.value)}
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1 text-sm font-semibold">Lucky Number</label>
          <input
            className="w-full border px-2 py-1"
            value={luckyNumber}
            onChange={e => setLuckyNumber(e.target.value)}
          />
        </div>

        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="bg-gray-300 px-3 py-1 rounded">Cancel</button>
          <button onClick={handleSave} className="bg-blue-600 text-white px-3 py-1 rounded">Save</button>
        </div>
      </div>
    </div>
  );
};

export default EditBetModal;
